import moment from "moment";
import Vue from "vue";

export default {
    MEETING_NOTE_INIT: function(state, data) {
        state.meetingNoteList = data || [];
        let ongoingNote = state.meetingNoteList.find(note => !note.endDate)
        if(!!ongoingNote && !ongoingNote.endDate){
            let startDate = moment(ongoingNote.startDate);
            let now = moment();
            state.writingTime = now.diff(startDate);

            if(!state.timerIntervalId) {
                state.timerIntervalId = setInterval(() => {
                    this.commit("meetingNote/ADD_MEETING_NOTE_TIME", {meetingNote: ongoingNote})
                }, state.timerIntervalTerm)
            }
        }

        state.meetingNoteList = state.meetingNoteList
          .map(meetingNote => {
              if (!meetingNote.endDate) {
                  return meetingNote
              }

              const now = moment()
              const endDate = moment(meetingNote.endDate)
              const diff = now.diff(endDate)

              if (diff < state.downloadTime) {
                  this.commit("meetingNote/CHANGE_NOTE_SAVE_STATE", {meetingNoteId: meetingNote.meetingNoteId, isSaving: true})
                  setTimeout(() => {
                      this.commit("meetingNote/CHANGE_NOTE_SAVE_STATE", {meetingNoteId: meetingNote.meetingNoteId, isSaving: false})
                  }, state.downloadTime - diff)
                  return meetingNote
              } else {
                  this.commit("meetingNote/CHANGE_NOTE_SAVE_STATE", {meetingNoteId: meetingNote.meetingNoteId, isSaving: false})
              }

              return meetingNote
          })
    },
    ADD_MEETING_NOTE: function(state, {meetingNote}) {
        state.meetingNoteList.push(meetingNote);

        if(!state.timerIntervalId) {
            state.timerIntervalId = setInterval(() => {
                this.commit("meetingNote/ADD_MEETING_NOTE_TIME", {meetingNote})
            }, state.timerIntervalTerm)
        }
    },
    ADD_MEETING_NOTE_TIME: function(state, {meetingNote}) {
        state.writingTime += state.timerIntervalTerm;
    },
    STOP_MEETING_NOTE: function(state, {meetingNoteId, endDate}) {
        const meetingNote = state.meetingNoteList.find(note => note.meetingNoteId == meetingNoteId)
        if(!meetingNote) return;

        meetingNote.endDate = endDate;
        this.commit("meetingNote/CHANGE_NOTE_SAVE_STATE", {meetingNoteId: meetingNote.meetingNoteId, isSaving: true})
        setTimeout(() => {
            this.commit("meetingNote/CHANGE_NOTE_SAVE_STATE", {meetingNoteId: meetingNote.meetingNoteId, isSaving: false})
        }, state.downloadTime)
        clearInterval(state.timerIntervalId)
        state.timerIntervalId = null;
        state.writingTime = 0;
    },
    DELETE_MEETING_NOTE: function(state, {meetingNoteId}) {
        let idx = state.meetingNoteList.findIndex(note => note.meetingNoteId == meetingNoteId);
        if(idx < 0)
            return;
        state.meetingNoteList.splice(idx, 1);
    },
    UPDATE_MEETING_NOTE_SUMMARY_STATE: function(state, {meetingNoteId, summaryState}) {
        const meetingNote = state.meetingNoteList.find(note => note.meetingNoteId == meetingNoteId)
        if(!meetingNote) return;

        meetingNote.summaryState = summaryState;
    },
    UPDATE_MEETING_NOTE_SUMMARY: function(state, {meetingNoteId, summary}) {
        const meetingNote = state.meetingNoteList.find(note => note.meetingNoteId == meetingNoteId)
        if(!meetingNote) return;

        Vue.set(meetingNote, 'summary', summary);
    },
    CHANGE_NOTE_WRITING_TIME: function(state, data) {
        state.writingTime = data || 0;
    },
    ADD_STT_TO_MEETING_NOTE: function(state, data) {
        const ongoingNote = state.meetingNoteList.find(note => !note.endDate)
        if(!ongoingNote) return
        if(!ongoingNote.stt) {
            Vue.set(ongoingNote, 'stt', []);
        }

        ongoingNote.stt.push(data)
    },
    ADD_STT_TRANSLATION: function(state, data) {
        const note = state.meetingNoteList.find(note => !note.endDate)
        const sttItem = note.stt?.find(stt => stt.syncTranslationUUID === data.syncTranslationUUID)
        // sttItem.translationValue = data.translateData.translatedText
        Vue.set(sttItem, 'translation', data.translateData.translatedText)
    },
    MEETING_NOTE_STT_INIT: function(state, {meetingNoteId, data}) {
        const meetingNote = state.meetingNoteList.find(note => note.meetingNoteId === meetingNoteId)
        if(!meetingNote) return

        meetingNote.stt
            ? meetingNote.stt = data
            : Vue.set(meetingNote, 'stt', data);
    },
    CHANGE_NOTE_SAVE_STATE: function(state, {meetingNoteId, isSaving}) {
        const meetingNote = state.meetingNoteList.find(note => note.meetingNoteId === meetingNoteId)
        if (!meetingNote) return

        if (meetingNote.isSaving === undefined) {
            Vue.set(meetingNote, 'isSaving', isSaving)
        }
        meetingNote.isSaving = isSaving
    }
}
